export const API_ROUTES = {
  NEWS: `${process.env.REACT_APP_API_BASE}/v1/news`,
  ME: `${process.env.REACT_APP_API_BASE}/v1/auth/me`,
  SEARCH: `${process.env.REACT_APP_API_BASE}/v1/search`,
  LAYOUT: `${process.env.REACT_APP_API_BASE}/v1/layout`,
  PERSONS: `${process.env.REACT_APP_API_BASE}/v1/persons`,
  PODCAST: `${process.env.REACT_APP_API_BASE}/v1/podcasts`,
  LOGIN: `${process.env.REACT_APP_API_BASE}/v1/auth/login`,
  PROJECTS: `${process.env.REACT_APP_API_BASE}/v1/projects`,
  REFRESH: `${process.env.REACT_APP_API_BASE}/v1/auth/refresh`,
  CATEGORIES: `${process.env.REACT_APP_API_BASE}/v1/categories`,
  FOLLOW_NEWS: `${process.env.REACT_APP_API_BASE}/v1/follow/news`,
  FOLLOW_CHECK: `${process.env.REACT_APP_API_BASE}/v1/follow/check`,
  FOLLOW_PERSON: `${process.env.REACT_APP_API_BASE}/v1/follow/person`,
  FOLLOW_PROJECT: `${process.env.REACT_APP_API_BASE}/v1/follow/project`,
};
